.ContextMenuCategory {
  background-color: var(--context-menu-background-color);
  color: var(--context-menu-category-color, rgba(255, 255, 255, 0.75));
  font-family: var(--context-menu-font-family, sans-serif);
  font-size: var(--context-menu-category-font-size, 14px);
  padding: var(--context-menu-category-padding, 0.25rem 1rem);
  user-select: none;
  display: flex;
  align-items: center;
  gap: 1ch;
  min-height: var(--context-menu-category-height, 1.5rem);
}
